__turbopack_context__.v({
  "bottomContainer": "FREYHW_bottomContainer",
  "button": "FREYHW_button",
  "container": "FREYHW_container",
  "content": "FREYHW_content",
  "header": "FREYHW_header",
  "image": "FREYHW_image",
  "imageContainer": "FREYHW_imageContainer",
  "list": "FREYHW_list",
  "listItem": "FREYHW_listItem",
  "listItemContent": "FREYHW_listItemContent",
  "listItemHeader": "FREYHW_listItemHeader",
  "listItemIcon": "FREYHW_listItemIcon",
  "listItemNumber": "FREYHW_listItemNumber",
  "textContent": "FREYHW_textContent",
});
